<template>
    <component
        :is="componentName"
        :key="componentKey"
        :field="field"
        :value="value"
        :readonly="readonly"
        @change="onChange"/>
</template>

<script>
import {FieldEditorTypes} from '@/types/document-viewer/field/modules/editor'

export default {
    name: 'DocumentViewerFieldEditor',
    components: {
        [`EDITOR-${FieldEditorTypes.TEXT}`]: () => import(/* webpackChunkName: "editor_text" */ './editors/DocFieldEditorText'),
        [`EDITOR-${FieldEditorTypes.NUMERIC}`]: () => import(/* webpackChunkName: "editor_numeric" */ './editors/DocFieldEditorNumeric'),
        [`EDITOR-${FieldEditorTypes.DATE}`]: () => import(/* webpackChunkName: "editor_date" */ './editors/DocFieldEditorDate'),
        [`EDITOR-${FieldEditorTypes.DD_SINGLE}`]: () => import(/* webpackChunkName: "editor_select" */ './editors/DocFieldEditorSelect'),
        [`EDITOR-${FieldEditorTypes.DD_MULTIPLE}`]: () => import(/* webpackChunkName: "editor_select" */ './editors/DocFieldEditorSelect'),
        'EDITOR-TREESELECT': () => import(/* webpackChunkName: "editor_treeselect" */ './editors/treeselect/DocFieldEditorTreeselect.vue'),
        'EDITOR-FORM-TYPE': () => import(/* webpackChunkName: "editor_form_type" */ './editors/DocFieldEditorFormType'),
        'EDITOR-SKU': () => import(/* webpackChunkName: "editor_sku" */ './editors/DocFieldEditorSelectSku')
    },
    props: {
        field: {
            // FormField
        },
        value: {},
        readonly: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        editor() {
            return this.field.editor || {}
        },

        // Exclude default value from editor re-rendering key
        // since it updates itself and loses focus after one char type)
        componentKey() {
            return `EDITOR-${JSON.stringify({...this.editor, default: ''})}`
        },

        componentName() {
            if (this.isDocTypeField) {
                return 'EDITOR-FORM-TYPE'
            } else if (this.isLinesSkuField) {
                return 'EDITOR-SKU'
            } else if (this.isTreeselect) {
                return 'EDITOR-TREESELECT'
            }
            return `EDITOR-${this.editor.type}`
        },

        isDocTypeField() {
            return this.field.path === 'type'
        },

        isLinesSkuField() {
            return this.field.path === 'lines.sku'
        },

        isTreeselect() {
            return FieldEditorTypes.DD_SINGLE === this.editor.type &&
                !!this.editor.select && this.editor.select.isTreeselect
        }
    },
    methods: {
        onChange(data) {
            this.$emit('change', data)
        }
    }
}
</script>
